import { Component, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NotificationsService } from "angular2-notifications";
import { Router, NavigationEnd } from "@angular/router";

import { SharedCommonService } from "app/shared/shared-common.service";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

	public AlertOptions = {};

	public ConfirmationOptions = {};

	public NotificationsOptions = {
		position: ["top", "right"],
		timeOut: 4000,
		lastOnBottom: true
	};

	fullScreen: boolean = false;
	_subscription;
	loaded: boolean = false;

    constructor(private router: Router, private commonService: SharedCommonService, private busyLoaderService: BusyLoaderService) { }

    ngOnInit() {
		this._subscription = this.commonService.FullScreen.subscribe((value: boolean) => {
			this.fullScreen = value;
		});

		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0, 0)
		});
	};

	ngAfterViewChecked() {
		setTimeout(() => {
            this.loaded = true;
            this.busyLoaderService.SetLoadingText("Loading");
		}, 2500);
	};

	ngOnDestroy() {
		this._subscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts